import classNames from '../../../../globals/classNames';

export default (element, isVisible) => {
	element.classList.toggle(classNames.search.active, isVisible);
};
